// extracted by mini-css-extract-plugin
export var collapsedSummary = "_qr-0";